import { Grid2 } from "@mui/material";
import React from "react";
import DisplayDetailsCard from "../../components/DisplayDetailsCard";
import { getTeamProfilePic } from "../../uttils/common";
import { useNavigate } from "react-router-dom";

const Teams = ({ teams }) => {
  const navigate = useNavigate();

  const _onTeamDetailsClick = (item) => {
    navigate("/user/teamDetails", { item: item });
  };
  return (
    <Grid2 container size={12}>
      {teams?.map((item) => (
        <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
          <DisplayDetailsCard
            heading={item?.teamName}
            subtitle={""}
            location={
              (`${item?.teamLocation?.name}`, `${item.teamLocation?.stateName}`)
            }
            displayRightIcon
            onClick={(item) => _onTeamDetailsClick(item)}
            imageLogo={getTeamProfilePic(item?.logo)}
            enableShadow
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Teams;
